import { initialState, RegionsState } from './selectors';
import * as actions from './actions';

export default (
  state: RegionsState = initialState,
  action: actions.RegionsAction,
) => {
  switch (action.type) {
    case actions.REGIONS_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.REGIONS_ACTIONS.SUCCEEDED: {
      const { payload } = action as actions.RegionsSucceeded;
      return { ...state, loading: false, regions: payload.regions };
    }

    case actions.REGIONS_ACTIONS.FAILED: {
      const { error } = action as actions.RegionsFailed;
      return { ...state, error, loading: false };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/Regions/services/reducer.ts